import { render } from "./AccountManagementDialog.vue?vue&type=template&id=efc2af68"
import script from "./AccountManagementDialog.vue?vue&type=script&lang=js"
export * from "./AccountManagementDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__